import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  gap: 5rem;
  margin-bottom: 0.5rem;
`;

export const TextBlock = styled.div`
  flex: 1;
  /* Adicione estilos adicionais para o bloco de texto, se necessário */
`;

export const CardBlock = styled.div`
  max-width: 16.88rem;
  flex: 1;
`;

export const LinksContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-top: 2rem;

  & * > span {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.blue6};
    text-decoration: underline;
    font-weight: 600;
  }
`;

export const SkeletonContainer = styled.div`
  width: 35rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    width: 40rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.laptopL}) {
    width: 47.625rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: 47.625rem;
  }
`;
